<div class="modal-wrapper modal-large">
    <section class="page-title">
        <h1><strong>Vincular pessoa</strong></h1>
        <mat-icon (click)="fechar()" style="cursor: pointer;">
            close
        </mat-icon>
    </section>

    <section class="filtros">
        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Buscar por nome, área ou cargo </mat-label>
            <input matInput type="text" (input)="aplicarFiltro($event)" [(ngModel)]="filterValue"
                placeholder="Digite para filtrar" />
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </section>

    <div class="table-container">
        <table mat-table [dataSource]="dataSource" matSort class="use-divider-between use-sticky-header">
            <ng-container matColumnDef="nome">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear> Nome completo </th>
                <td mat-cell *matCellDef="let pessoa" style="height: 65px;">
                    <mat-radio-group [(ngModel)]="idSelecionado">
                        <mat-radio-button [value]="pessoa.idPessoa" style="cursor: pointer;">
                            {{pessoa.nomeCompleto}}
                        </mat-radio-button>
                    </mat-radio-group>
                </td>   
            </ng-container>


            <ng-container matColumnDef="area">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear style="width: 15%;"> Área </th>
                <td mat-cell *matCellDef="let pessoa"> {{pessoa.area}} </td>
            </ng-container>

            <ng-container matColumnDef="cargo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear style="width:35%;"> Cargo </th>
                <td mat-cell *matCellDef="let pessoa"> {{pessoa.cargo}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <div class="modal-footer">
        <button matButton="filled" [disabled]="!idSelecionado" (click)="vincularEmpresa()">
            Vincular pessoa selecionada
        </button>
    </div>
</div>